
// import { ICompany } from "@/interfaces/company";
// import { IMetasCheckout } from "@/interfaces/metasCheckout";
import CreateOcorrencia from '@/views/main/checkout/Create.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import { companyStore, mainStore, metaStore, timeStore } from '@/store';
import { Component, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { differenceInDays, parse } from 'date-fns';
import { userActionStore } from '../../../utils/store-accessor';
import RoutesMetas from './RoutesMetas.vue';

@Component({
  components: {
    CreateOcorrencia,
    ShowPopup,
    RoutesMetas,
  },
})
export default class List extends Vue {
  @Watch('selectedUser', { immediate: true })
  async onChangeSelectedUser(id) {
    await this.updateTime(id);
  }
  public selectedUser: any = this.currentUser!.id!;
  public selectedCompanies: any[] = [];
  public isLoading = true;
  public isReloaded = false;
  public clickedButton: any = null;
  public showCalendarDateStart = false;
  public showCalendarDateEnd = false;
  public headersSemTotal = ['coord_pedagogico', 'gerente_comercial', 'cpa_retencao'];
  public dateStart: any = new Date(this.today.setDate(1)).toISOString().split('T')[0];
  public dateEnd: any = new Date(
    new Date().setDate(this.getMonthLastDay(this.today.getMonth(), this.today.getFullYear()))
  )
    .toISOString()
    .split('T')[0];

  get today() {
    return new Date();
  }

  get currentYear() {
    return this.today.getFullYear();
  }

  get currentUserCompanies() {
    return _.map(_.filter(this.times, { user_id: this.currentUser!.id }), 'company_id');
  }

  public propCompany: any = {};

  public propCheckoutId: number = 0;

  public headers = [
    {
      text: `Unidade`,
      value: `nome_fantasia`,
      align: 'left',
    },
    {
      text: `Matrículas`,
      value: `matriculas_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Meta`,
      value: `meta_matriculas_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Livros`,
      value: `livros_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Meta`,
      value: `meta_livros_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Alunos`,
      value: `alunos_ativos_inicial_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Alunos`,
      value: `alunos_ativos_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Meta`,
      value: `meta_alunos_ativos_${this.currentYear}`,
      align: 'center',
    },
    {
      text: `Gerente`,
      value: `gerente_comercial`,
      align: 'center',
    },
    {
      text: `Coordenador`,
      value: `coord_pedagogico`,
      align: 'center',
    },
    {
      text: `CPA`,
      value: `cpa_retencao`,
      align: 'center',
    },
    {
      text: `Comercial`,
      value: `ocorrencias_comercial`,
      align: 'center',
      class: 'ocorrencia',
    },
    {
      text: `Pedagógico`,
      value: `ocorrencias_pedagogico`,
      align: 'center',
      class: 'ocorrencia',
    },
    {
      text: `Retenção`,
      value: `ocorrencias_retencao`,
      align: 'center',
      class: 'ocorrencia',
    },
  ];

  get metas() {
    if (this.selectedCompanies.length > 0) {
      return _.filter(metaStore.metas, (m) => this.selectedCompanies.includes(m['id']));
    }
    return metaStore.metas;
  }

  get companies() {
    return companyStore.companies;
  }

  get times() {
    return _.orderBy(timeStore.times, 'user_full_name', 'asc');
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public isInauguracao(item: any) {
    const date = item.inauguracao;
    if (!date) return;

    const formatedDate = date.split('T')[0];
    return differenceInDays(parse(formatedDate || formatedDate, 'yyyy-MM-dd', new Date()), new Date()) >= -30;
  }

  public isReinauguracao(item: any) {
    const date = item.data_reinauguracao;
    if (!date) return;

    const formatedDate = date.split('T')[0];
    return differenceInDays(parse(formatedDate || formatedDate, 'yyyy-MM-dd', new Date()), new Date()) >= -30;
  }

  public async showCreateCheckout(checkoutId: number, companyId: number) {
    this.propCheckoutId = checkoutId;
    this.propCompany = await companyStore.getByID(companyId);
    const el: any = this.$refs.showCreateCheckout;
    el.show();
  }

  public async reloadCheckouts() {
    const el: any = this.$refs.showCreateCheckout;
    el.dialog = false;
    this.isLoading = true;
    await metaStore.getMetas();
    this.isLoading = false;
  }

  public updateTime(id) {
    if (!!id) {
      const userCompanies = _.filter(this.times, (t) => t['user_id'] === id);
      this.selectedCompanies = _.map(userCompanies, (uc) => uc['company_id']);
    } else {
      this.selectedCompanies = [];
    }
  }

  public getTotal(value: string) {
    const soma = _.sumBy(this.metas, value);
    return soma;
  }

  public async setSemana(semana: number) {
    this.clickedButton = semana;
    switch (semana) {
      case -1:
        const lastMonth = new Date(new Date(this.today.setDate(15)).setMonth(this.today.getMonth() - 1));

        this.dateStart = new Date(lastMonth.setDate(1)).toISOString().split('T')[0];
        this.dateEnd = new Date(lastMonth.setDate(this.getMonthLastDay(lastMonth.getMonth(), this.currentYear)))
          .toISOString()
          .split('T')[0];
        break;
      case 0:
        this.dateStart = new Date(this.today.setDate(1)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(this.getMonthLastDay(this.today.getMonth(), this.currentYear)))
          .toISOString()
          .split('T')[0];
        break;
      case 1:
        this.dateStart = new Date(this.today.setDate(1)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(7)).toISOString().split('T')[0];
        break;
      case 2:
        this.dateStart = new Date(this.today.setDate(8)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(14)).toISOString().split('T')[0];
        break;
      case 3:
        this.dateStart = new Date(this.today.setDate(15)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(21)).toISOString().split('T')[0];
        break;
      case 4:
        this.dateStart = new Date(this.today.setDate(22)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(28)).toISOString().split('T')[0];
        break;
      case 5:
        this.dateStart = new Date(this.today.setDate(29)).toISOString().split('T')[0];
        this.dateEnd = new Date(this.today.setDate(this.getMonthLastDay(this.today.getMonth(), this.currentYear)))
          .toISOString()
          .split('T')[0];
        break;
    }
    await this.getMetas(semana);
    this.clickedButton = null;
  }

  public getMonthLastDay(month: number, year?: number) {
    if (!year) {
      year = new Date().getFullYear();
    }
    var aux = new Date(year, month + 1, 0);
    return aux.getDate();
  }

  public async getMetas(semana?: number) {
    if (semana && ![1, 2, 3, 4].includes(semana)) {
      semana = 0;
    }

    this.isLoading = true;
    await metaStore.getMetas({
      date_initial: this.dateStart,
      date_final: this.dateEnd,
      semana: semana,
    });
    this.isReloaded = true;
    this.isLoading = false;
  }

  get userActions() {
    return userActionStore.userActions;
  }

  get allowSeeAllBonificacoes() {
    let action = this.userActions.find((x) => x.action_id == 40);

    if (!action) return false;

    return action.allow;
  }

  public async mounted() {
    await userActionStore.getUserActions(this.currentUser.id);
    // await this.getMetas();
    await timeStore.getTimes();
    this.isLoading = false;
  }
}
